import React from 'react';
import {
  Tab,
  TabIcon,
  TabIconProps,
  TabLink,
  TabLinkProps,
  TabLogoProps,
  TabText,
} from './tab';

import styles from './navigation.less';

export interface TeamTabProps extends TabLogoProps, TabLinkProps {
  displayName: string;
  expanded: boolean;
  orgId: string;
  linkTabs: TeamLinkSubTabProps[];
  selected: boolean;
}

interface TeamLinkSubTabProps extends TabLinkProps, TabIconProps {
  displayName: string;
  external?: boolean;
  selected: boolean;
}

export const TeamLinkSubTab: React.FunctionComponent<TeamLinkSubTabProps> = ({
  displayName,
  external,
  iconName,
  selected,
  ...props
}) => (
  <Tab>
    <TabLink
      selected={selected}
      className={external ? styles.externalLink : ''}
      indented
      small
      quiet
      {...props}
    >
      <TabIcon iconName={iconName} />
      <TabText>{displayName}</TabText>
      {external && (
        <TabIcon iconName={'forward'} className={styles.externalIcon} />
      )}
    </TabLink>
  </Tab>
);
